export interface PendingBiometricCredentials {
  serverUrl: string;
  username: string;
  password: string;
}

type SaveCredentials = (serverUrl: string, username: string, password: string) => Promise<void>;
type ContinueLogin = () => Promise<void>;

/**
 * Finish the optional biometric prompt without allowing Keychain storage to
 * block an already-authenticated user from entering the app.
 */
export async function completeBiometricSaveChoice(
  credentials: PendingBiometricCredentials | null,
  save: SaveCredentials,
  continueLogin: ContinueLogin,
): Promise<void> {
  try {
    if (credentials) {
      await save(credentials.serverUrl, credentials.username, credentials.password);
    }
  } catch (error) {
    console.warn("[Login] Could not save biometric credentials", error);
  } finally {
    await continueLogin();
  }
}
